export default __webpack_public_path__ + "static/media/IAMSmart.856d7736.jpg";